"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebAuthRouter = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const web_auth_schema_1 = require("./web.auth.schema");
const c = (0, core_1.initContract)();
exports.WebAuthRouter = c.router({
    register: {
        method: 'POST',
        path: '/register',
        body: web_auth_schema_1.WebContractRegisterRequestSchema,
        responses: { 201: (0, shared_1.createSuccessResponseSchema)(web_auth_schema_1.WebContractRegisterResponseSchema) },
    },
    login: {
        method: 'POST',
        path: '/login',
        body: shared_1.EmptyBodySchema,
        headers: shared_1.ContractAuthHeaderSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_auth_schema_1.WebContractLoginResponseSchema) },
    },
    loginWithProvider: {
        method: 'POST',
        path: '/login-provider',
        body: shared_1.EmptyBodySchema,
        headers: shared_1.ContractAuthHeaderSchema,
        responses: {
            200: (0, shared_1.createSuccessResponseSchema)(web_auth_schema_1.WebContractLoginResponseSchema),
            201: (0, shared_1.createSuccessResponseSchema)(web_auth_schema_1.WebContractLoginResponseSchema),
        },
    },
    getSession: {
        method: 'GET',
        path: '/session',
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_auth_schema_1.WebContractGetAuthSessionResponseSchema) },
    },
    logout: {
        method: 'DELETE',
        path: '/logout',
        body: shared_1.EmptyBodySchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(zod_1.z.undefined()) },
    },
    forgotPassword: {
        method: 'POST',
        path: '/forgot-password',
        body: web_auth_schema_1.WebContractForgotPasswordRequestSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(zod_1.z.undefined()) },
    },
}, { pathPrefix: '/auth' });
